import { jsxs as t, jsx as o } from "react/jsx-runtime";
const f = (s) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...s,
    children: [
      /* @__PURE__ */ o("g", { clipPath: "url(#firefox-colored_svg__a)", children: /* @__PURE__ */ t("g", { clipPath: "url(#firefox-colored_svg__b)", children: [
        /* @__PURE__ */ o(
          "path",
          {
            fill: "url(#firefox-colored_svg__c)",
            d: "M23.132 8.052c-.522-1.216-1.58-2.53-2.41-2.944a11.8 11.8 0 0 1 1.217 3.53l.002.019c-1.358-3.278-3.661-4.601-5.543-7.48-.095-.145-.19-.29-.283-.445a4 4 0 0 1-.132-.24 2 2 0 0 1-.18-.46.03.03 0 0 0-.007-.02.03.03 0 0 0-.02-.01.04.04 0 0 0-.022 0l-.006.003-.009.005.005-.008c-3.018 1.71-4.043 4.877-4.136 6.461a6.13 6.13 0 0 0-3.307 1.234 4 4 0 0 0-.31-.228 5.23 5.23 0 0 1-.034-2.843A8.9 8.9 0 0 0 5.065 6.79h-.006c-.476-.584-.442-2.51-.415-2.913q-.211.083-.401.206-.631.436-1.174.974-.618.607-1.124 1.304v.002-.002A9.7 9.7 0 0 0 .333 9.884l-.016.077a18 18 0 0 0-.118.726q0 .014-.003.026a11 11 0 0 0-.195 1.604v.06c.006 2.91 1.138 5.713 3.174 7.855s4.827 3.467 7.822 3.714a12.3 12.3 0 0 0 8.359-2.38c2.38-1.777 3.986-4.355 4.5-7.222q.028-.225.054-.45c.248-1.98-.02-3.99-.779-5.844zM9.285 17.157c.056.026.108.055.166.08l.008.005zM21.94 8.66v-.011l.002.012z"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            fill: "url(#firefox-colored_svg__d)",
            d: "M23.132 8.052c-.522-1.216-1.581-2.529-2.41-2.944a11.8 11.8 0 0 1 1.216 3.53v.01l.002.013a10.23 10.23 0 0 1-.373 7.85c-1.378 2.861-4.71 5.793-9.927 5.649-5.635-.155-10.602-4.205-11.528-9.508-.17-.836 0-1.26.085-1.94a8.4 8.4 0 0 0-.194 1.605v.06c.006 2.91 1.138 5.714 3.174 7.856s4.827 3.467 7.822 3.714a12.3 12.3 0 0 0 8.359-2.38c2.38-1.778 3.986-4.355 4.5-7.223q.029-.224.054-.45c.248-1.98-.02-3.99-.78-5.843z"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            fill: "url(#firefox-colored_svg__e)",
            d: "M23.132 8.052c-.522-1.216-1.581-2.529-2.41-2.944a11.8 11.8 0 0 1 1.216 3.53v.01l.002.013a10.23 10.23 0 0 1-.373 7.85c-1.378 2.861-4.71 5.793-9.927 5.649-5.635-.155-10.602-4.205-11.528-9.508-.17-.836 0-1.26.085-1.94a8.4 8.4 0 0 0-.194 1.605v.06c.006 2.91 1.138 5.714 3.174 7.856s4.827 3.467 7.822 3.714a12.3 12.3 0 0 0 8.359-2.38c2.38-1.778 3.986-4.355 4.5-7.223q.029-.224.054-.45c.248-1.98-.02-3.99-.78-5.843z"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            fill: "url(#firefox-colored_svg__f)",
            d: "M17.291 9.418q.038.026.075.053a6.4 6.4 0 0 0-1.116-1.41c-3.735-3.616-.979-7.838-.514-8.054L15.741 0c-3.018 1.71-4.043 4.877-4.135 6.461.14-.009.278-.02.422-.02a6.2 6.2 0 0 1 3.046.8 5.97 5.97 0 0 1 2.217 2.176"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            fill: "url(#firefox-colored_svg__g)",
            d: "M12.034 10.14c-.02.29-1.076 1.288-1.445 1.288-3.416 0-3.97 2-3.97 2 .15 1.686 1.363 3.074 2.83 3.806q.1.05.202.094.176.075.353.14c.503.172 1.03.27 1.563.292 5.99.272 7.148-6.933 2.827-9.025a4.25 4.25 0 0 1 2.897.681 5.97 5.97 0 0 0-2.218-2.175 6.2 6.2 0 0 0-3.046-.8c-.143 0-.282.01-.422.02a6.13 6.13 0 0 0-3.308 1.234c.183.15.39.35.826.766.815.777 2.906 1.583 2.91 1.678z"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            fill: "url(#firefox-colored_svg__h)",
            d: "M12.034 10.14c-.02.29-1.076 1.288-1.445 1.288-3.416 0-3.97 2-3.97 2 .15 1.686 1.363 3.074 2.83 3.806q.1.05.202.094.176.075.353.14c.503.172 1.03.27 1.563.292 5.99.272 7.148-6.933 2.827-9.025a4.25 4.25 0 0 1 2.897.681 5.97 5.97 0 0 0-2.218-2.175 6.2 6.2 0 0 0-3.046-.8c-.143 0-.282.01-.422.02a6.13 6.13 0 0 0-3.308 1.234c.183.15.39.35.826.766.815.777 2.906 1.583 2.91 1.678z"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            fill: "url(#firefox-colored_svg__i)",
            d: "M7.737 7.31c.098.06.178.113.248.16a5.23 5.23 0 0 1-.033-2.843A8.9 8.9 0 0 0 5.06 6.791c.058-.001 1.801-.032 2.677.52"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            fill: "url(#firefox-colored_svg__j)",
            d: "M.11 12.653c.927 5.303 5.893 9.354 11.529 9.507 5.217.143 8.55-2.789 9.926-5.648a10.23 10.23 0 0 0 .374-7.85V8.65q-.002-.014 0-.011l.002.02c.426 2.694-.99 5.302-3.203 7.07l-.006.015c-4.312 3.4-8.438 2.051-9.272 1.5l-.175-.084c-2.514-1.163-3.553-3.379-3.33-5.282a3.16 3.16 0 0 1-1.688-.458 3 3 0 0 1-1.158-1.275 4.657 4.657 0 0 1 4.417-.172 6.17 6.17 0 0 0 4.511.172c-.004-.094-2.095-.9-2.91-1.677-.436-.416-.643-.616-.826-.767a4 4 0 0 0-.31-.227l-.248-.16c-.877-.551-2.62-.52-2.677-.52H5.06c-.476-.583-.442-2.51-.415-2.913q-.211.083-.401.207-.631.436-1.174.973-.62.605-1.128 1.302v.002-.002A9.7 9.7 0 0 0 .33 9.886c-.006.024-.433 1.83-.222 2.767z"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            fill: "url(#firefox-colored_svg__k)",
            d: "M16.25 8.061c.439.417.814.892 1.116 1.41q.1.074.18.143c2.724 2.431 1.297 5.868 1.19 6.11 2.213-1.764 3.628-4.375 3.203-7.07-1.36-3.28-3.664-4.604-5.543-7.482q-.143-.216-.283-.445a4 4 0 0 1-.132-.24 2 2 0 0 1-.18-.46.03.03 0 0 0-.007-.02.03.03 0 0 0-.02-.01.04.04 0 0 0-.022 0l-.006.002-.009.005c-.465.213-3.22 4.439.515 8.052z"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            fill: "url(#firefox-colored_svg__l)",
            d: "M17.546 9.616a3 3 0 0 0-.18-.143l-.075-.053a4.25 4.25 0 0 0-2.897-.681c4.321 2.091 3.162 9.294-2.827 9.024a5.5 5.5 0 0 1-1.563-.292 6 6 0 0 1-.556-.233l.009.005c.835.552 4.96 1.9 9.272-1.5l.006-.016c.108-.243 1.535-3.68-1.19-6.11z"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            fill: "url(#firefox-colored_svg__m)",
            d: "M6.618 13.427s.555-2 3.971-2c.37 0 1.426-.999 1.445-1.288a6.17 6.17 0 0 1-4.51-.172 4.66 4.66 0 0 0-4.418.172c.25.525.653.967 1.158 1.275a3.16 3.16 0 0 0 1.689.458c-.223 1.902.815 4.118 3.329 5.282q.082.04.166.08c-1.467-.734-2.678-2.122-2.83-3.806"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            fill: "url(#firefox-colored_svg__n)",
            d: "M23.132 8.052c-.522-1.216-1.58-2.53-2.41-2.944a11.8 11.8 0 0 1 1.217 3.53l.002.019c-1.359-3.278-3.661-4.601-5.543-7.48-.095-.145-.19-.29-.283-.445a4 4 0 0 1-.132-.24 2 2 0 0 1-.18-.46.03.03 0 0 0-.007-.02.03.03 0 0 0-.02-.01.04.04 0 0 0-.022 0l-.006.003-.009.005.005-.008c-3.018 1.71-4.043 4.877-4.136 6.461.14-.01.28-.02.422-.02a6.2 6.2 0 0 1 3.047.8 5.97 5.97 0 0 1 2.217 2.176 4.25 4.25 0 0 0-2.897-.681c4.322 2.092 3.162 9.294-2.827 9.024a5.5 5.5 0 0 1-1.563-.292 7 7 0 0 1-.555-.233l.008.005-.175-.085q.082.04.167.08c-1.468-.734-2.68-2.122-2.83-3.806 0 0 .554-2 3.97-2 .37 0 1.427-.999 1.446-1.288-.005-.094-2.096-.9-2.911-1.678C8.69 8.05 8.484 7.85 8.3 7.7a4 4 0 0 0-.31-.227 5.23 5.23 0 0 1-.034-2.843 8.9 8.9 0 0 0-2.892 2.164H5.06c-.476-.585-.443-2.511-.416-2.914q-.211.083-.4.206-.633.437-1.175.974-.618.607-1.123 1.305v.002-.002A9.7 9.7 0 0 0 .334 9.887l-.016.077a19 19 0 0 0-.139.733 13 13 0 0 0-.177 1.622v.06c.005 2.91 1.138 5.714 3.173 7.856s4.827 3.467 7.823 3.714a12.3 12.3 0 0 0 8.358-2.38c2.381-1.778 3.987-4.355 4.5-7.223q.029-.224.055-.45c.247-1.98-.02-3.99-.78-5.843zm-1.192.597.002.013z"
          }
        )
      ] }) }),
      /* @__PURE__ */ t("defs", { children: [
        /* @__PURE__ */ t(
          "radialGradient",
          {
            id: "firefox-colored_svg__d",
            cx: 0,
            cy: 0,
            r: 1,
            gradientTransform: "matrix(25.0478 0 0 24.2491 20.77 2.701)",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { offset: 0.129, stopColor: "#FFBD4F" }),
              /* @__PURE__ */ o("stop", { offset: 0.186, stopColor: "#FFAC31" }),
              /* @__PURE__ */ o("stop", { offset: 0.247, stopColor: "#FF9D17" }),
              /* @__PURE__ */ o("stop", { offset: 0.283, stopColor: "#FF980E" }),
              /* @__PURE__ */ o("stop", { offset: 0.403, stopColor: "#FF563B" }),
              /* @__PURE__ */ o("stop", { offset: 0.467, stopColor: "#FF3750" }),
              /* @__PURE__ */ o("stop", { offset: 0.71, stopColor: "#F5156C" }),
              /* @__PURE__ */ o("stop", { offset: 0.782, stopColor: "#EB0878" }),
              /* @__PURE__ */ o("stop", { offset: 0.86, stopColor: "#E50080" })
            ]
          }
        ),
        /* @__PURE__ */ t(
          "radialGradient",
          {
            id: "firefox-colored_svg__e",
            cx: 0,
            cy: 0,
            r: 1,
            gradientTransform: "matrix(25.0478 0 0 24.2491 11.47 12.605)",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { offset: 0.3, stopColor: "#960E18" }),
              /* @__PURE__ */ o("stop", { offset: 0.351, stopColor: "#B11927", stopOpacity: 0.74 }),
              /* @__PURE__ */ o("stop", { offset: 0.435, stopColor: "#DB293D", stopOpacity: 0.343 }),
              /* @__PURE__ */ o("stop", { offset: 0.497, stopColor: "#F5334B", stopOpacity: 0.094 }),
              /* @__PURE__ */ o("stop", { offset: 0.53, stopColor: "#FF3750", stopOpacity: 0 })
            ]
          }
        ),
        /* @__PURE__ */ t(
          "radialGradient",
          {
            id: "firefox-colored_svg__f",
            cx: 0,
            cy: 0,
            r: 1,
            gradientTransform: "matrix(18.1441 0 0 17.5656 14.57 -2.701)",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { offset: 0.132, stopColor: "#FFF44F" }),
              /* @__PURE__ */ o("stop", { offset: 0.252, stopColor: "#FFDC3E" }),
              /* @__PURE__ */ o("stop", { offset: 0.506, stopColor: "#FF9D12" }),
              /* @__PURE__ */ o("stop", { offset: 0.526, stopColor: "#FF980E" })
            ]
          }
        ),
        /* @__PURE__ */ t(
          "radialGradient",
          {
            id: "firefox-colored_svg__g",
            cx: 0,
            cy: 0,
            r: 1,
            gradientTransform: "matrix(11.9256 0 0 11.5453 8.68 18.907)",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { offset: 0.353, stopColor: "#3A8EE6" }),
              /* @__PURE__ */ o("stop", { offset: 0.472, stopColor: "#5C79F0" }),
              /* @__PURE__ */ o("stop", { offset: 0.669, stopColor: "#9059FF" }),
              /* @__PURE__ */ o("stop", { offset: 1, stopColor: "#C139E6" })
            ]
          }
        ),
        /* @__PURE__ */ t(
          "radialGradient",
          {
            id: "firefox-colored_svg__h",
            cx: 0,
            cy: 0,
            r: 1,
            gradientTransform: "matrix(6.14688 -1.43874 1.63636 6.99122 12.681 10.523)",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { offset: 0.206, stopColor: "#9059FF", stopOpacity: 0 }),
              /* @__PURE__ */ o("stop", { offset: 0.278, stopColor: "#8C4FF3", stopOpacity: 0.064 }),
              /* @__PURE__ */ o("stop", { offset: 0.747, stopColor: "#7716A8", stopOpacity: 0.45 }),
              /* @__PURE__ */ o("stop", { offset: 0.975, stopColor: "#6E008B", stopOpacity: 0.6 })
            ]
          }
        ),
        /* @__PURE__ */ t(
          "radialGradient",
          {
            id: "firefox-colored_svg__i",
            cx: 0,
            cy: 0,
            r: 1,
            gradientTransform: "matrix(8.58073 0 0 8.30712 11.16 1.8)",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { stopColor: "#FFE226" }),
              /* @__PURE__ */ o("stop", { offset: 0.121, stopColor: "#FFDB27" }),
              /* @__PURE__ */ o("stop", { offset: 0.295, stopColor: "#FFC82A" }),
              /* @__PURE__ */ o("stop", { offset: 0.502, stopColor: "#FFA930" }),
              /* @__PURE__ */ o("stop", { offset: 0.732, stopColor: "#FF7E37" }),
              /* @__PURE__ */ o("stop", { offset: 0.792, stopColor: "#FF7139" })
            ]
          }
        ),
        /* @__PURE__ */ t(
          "radialGradient",
          {
            id: "firefox-colored_svg__j",
            cx: 0,
            cy: 0,
            r: 1,
            gradientTransform: "matrix(36.6107 0 0 35.4433 17.98 -3.601)",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { offset: 0.113, stopColor: "#FFF44F" }),
              /* @__PURE__ */ o("stop", { offset: 0.456, stopColor: "#FF980E" }),
              /* @__PURE__ */ o("stop", { offset: 0.622, stopColor: "#FF5634" }),
              /* @__PURE__ */ o("stop", { offset: 0.716, stopColor: "#FF3647" }),
              /* @__PURE__ */ o("stop", { offset: 0.904, stopColor: "#E31587" })
            ]
          }
        ),
        /* @__PURE__ */ t(
          "radialGradient",
          {
            id: "firefox-colored_svg__k",
            cx: 0,
            cy: 0,
            r: 1,
            gradientTransform: "matrix(2.81556 25.8299 -17.49736 1.90728 14.937 -1.636)",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { stopColor: "#FFF44F" }),
              /* @__PURE__ */ o("stop", { offset: 0.06, stopColor: "#FFE847" }),
              /* @__PURE__ */ o("stop", { offset: 0.168, stopColor: "#FFC830" }),
              /* @__PURE__ */ o("stop", { offset: 0.304, stopColor: "#FF980E" }),
              /* @__PURE__ */ o("stop", { offset: 0.356, stopColor: "#FF8B16" }),
              /* @__PURE__ */ o("stop", { offset: 0.455, stopColor: "#FF672A" }),
              /* @__PURE__ */ o("stop", { offset: 0.57, stopColor: "#FF3647" }),
              /* @__PURE__ */ o("stop", { offset: 0.737, stopColor: "#E31587" })
            ]
          }
        ),
        /* @__PURE__ */ t(
          "radialGradient",
          {
            id: "firefox-colored_svg__l",
            cx: 0,
            cy: 0,
            r: 1,
            gradientTransform: "matrix(22.853 0 0 22.1243 11.16 4.802)",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { offset: 0.137, stopColor: "#FFF44F" }),
              /* @__PURE__ */ o("stop", { offset: 0.48, stopColor: "#FF980E" }),
              /* @__PURE__ */ o("stop", { offset: 0.592, stopColor: "#FF5634" }),
              /* @__PURE__ */ o("stop", { offset: 0.655, stopColor: "#FF3647" }),
              /* @__PURE__ */ o("stop", { offset: 0.904, stopColor: "#E31587" })
            ]
          }
        ),
        /* @__PURE__ */ t(
          "radialGradient",
          {
            id: "firefox-colored_svg__m",
            cx: 0,
            cy: 0,
            r: 1,
            gradientTransform: "matrix(25.0137 0 0 24.2161 17.05 6.002)",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { offset: 0.094, stopColor: "#FFF44F" }),
              /* @__PURE__ */ o("stop", { offset: 0.231, stopColor: "#FFE141" }),
              /* @__PURE__ */ o("stop", { offset: 0.509, stopColor: "#FFAF1E" }),
              /* @__PURE__ */ o("stop", { offset: 0.626, stopColor: "#FF980E" })
            ]
          }
        ),
        /* @__PURE__ */ t(
          "linearGradient",
          {
            id: "firefox-colored_svg__c",
            x1: 21.542,
            x2: 2.22,
            y1: 3.717,
            y2: 22.974,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { offset: 0.048, stopColor: "#FFF44F" }),
              /* @__PURE__ */ o("stop", { offset: 0.111, stopColor: "#FFE847" }),
              /* @__PURE__ */ o("stop", { offset: 0.225, stopColor: "#FFC830" }),
              /* @__PURE__ */ o("stop", { offset: 0.368, stopColor: "#FF980E" }),
              /* @__PURE__ */ o("stop", { offset: 0.401, stopColor: "#FF8B16" }),
              /* @__PURE__ */ o("stop", { offset: 0.462, stopColor: "#FF672A" }),
              /* @__PURE__ */ o("stop", { offset: 0.534, stopColor: "#FF3647" }),
              /* @__PURE__ */ o("stop", { offset: 0.705, stopColor: "#E31587" })
            ]
          }
        ),
        /* @__PURE__ */ t(
          "linearGradient",
          {
            id: "firefox-colored_svg__n",
            x1: 21.3,
            x2: 4.881,
            y1: 3.618,
            y2: 20.581,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { offset: 0.167, stopColor: "#FFF44F", stopOpacity: 0.8 }),
              /* @__PURE__ */ o("stop", { offset: 0.266, stopColor: "#FFF44F", stopOpacity: 0.634 }),
              /* @__PURE__ */ o("stop", { offset: 0.489, stopColor: "#FFF44F", stopOpacity: 0.217 }),
              /* @__PURE__ */ o("stop", { offset: 0.6, stopColor: "#FFF44F", stopOpacity: 0 })
            ]
          }
        ),
        /* @__PURE__ */ o("clipPath", { id: "firefox-colored_svg__a", children: /* @__PURE__ */ o("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }),
        /* @__PURE__ */ o("clipPath", { id: "firefox-colored_svg__b", children: /* @__PURE__ */ o("path", { fill: "#fff", d: "M0 0h24v24H0z" }) })
      ] })
    ]
  }
);
export {
  f as default
};
